import React from 'react';
import { observer } from 'mobx-react';
import { ForumStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class ForumCreate extends React.Component {

  onCreate = title => {
    ForumStore.create({ data: {title} });
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a title'
        onCreate={this.onCreate}
      />
    );
  }
}

export default ForumCreate;
